import { showPopup } from 'publisher/actionsManagement'
import { getEntityById } from 'publisher/reducers/pageReducer'
import { usePage } from 'publisher/store'
import { dispatchPopupOpenedCustomEvent } from 'publisher/utils/popupUtils'
import React, { SyntheticEvent } from 'react'
import { useDispatch } from 'react-redux'
import { useRemoveUnavailablePopups } from 'src/publisher/hooks/use-remove-unavailable-popups'
import { CommonPublisherButtonEntityOrSubEntity } from 'src/publisher/shared/components/button/common-publisher-button-entity-or-sub-entity'
import { ShowPopupActionButtonEntityInterface } from 'src/shared/entities/button/show-popup.action-button.schema'
import { ShowPopupWebsiteActionButtonEntityInterface } from 'src/shared/entities/website-button/show-popup-website-button.schema'

export const TEST_ID = 'show-popup-button'

export interface ShowPopupButtonProps {
  entity:
    | ShowPopupActionButtonEntityInterface
    | ShowPopupWebsiteActionButtonEntityInterface
}

const ShowPopupButton = ({ entity }: ShowPopupButtonProps) => {
  const dispatch = useDispatch()
  const popupEntity = usePage(page => getEntityById(page, entity.popup))

  const openPopup = (e: SyntheticEvent) => {
    e.preventDefault()
    if ('popup' in entity && entity.popup) {
      dispatch(showPopup(entity.popup))
    }
    // use small timeout in order to render popup
    if (popupEntity) {
      dispatchPopupOpenedCustomEvent(
        popupEntity.options
          ? popupEntity.options.attrId
          : popupEntity.htmlAttrId,
      )
    }
  }

  useRemoveUnavailablePopups({
    keys: ['popup'],
    entity,
  })

  return (
    <CommonPublisherButtonEntityOrSubEntity
      entityOrSubEntity={entity}
      onClick={openPopup}
      testId={TEST_ID}
    />
  )
}

export default ShowPopupButton
